var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classfiy-list-box"},[_c('div',{staticClass:"list-box"},_vm._l((_vm.list),function(item,index){return _c('span',{key:index,on:{"click":function($event){return _vm.toGoodsList(item.catName1)}}},[_vm._v(_vm._s(item.catName1))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }